(() => {
  document.querySelectorAll('.res-form-parceiro').forEach((section) => {
    const form = section.querySelector('.res-form');
    if (!form) return;

    const steps   = form.querySelectorAll('.res-form__step');
    const btnNexts = form.querySelectorAll('.res-form__btn-next');
    const btnBacks = form.querySelectorAll('.res-form__btn-back');

    let currentStep = 0;

    // ── Masks ──────────────────────────────────────────────

    form.querySelectorAll('.js-mask-phone').forEach((el) => {
      el.addEventListener('input', () => {
        let v = el.value.replace(/\D/g, '').slice(0, 11);
        if (v.length > 6) v = v.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
        else if (v.length > 2) v = v.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
        else if (v.length > 0) v = v.replace(/^(\d{0,2})/, '($1');
        el.value = v;
      });
    });

    form.querySelectorAll('.js-mask-uf').forEach((el) => {
      el.addEventListener('input', () => {
        el.value = el.value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
      });
    });

    // ── Checkboxes → hidden inputs ─────────────────────────

    const syncCheckGroup = (checks, hidden) => {
      if (!hidden) return;
      hidden.value = [...checks]
        .filter((c) => c.checked)
        .map((c) => c.value)
        .join(', ');
    };

    const profChecks   = form.querySelectorAll('.js-profissao-check');
    const profHidden   = form.querySelector('.js-profissao-hidden');
    profChecks.forEach((c) => c.addEventListener('change', () => syncCheckGroup(profChecks, profHidden)));

    const intChecks    = form.querySelectorAll('.js-interesse-check');
    const intHidden    = form.querySelector('.js-interesse-hidden');
    intChecks.forEach((c) => c.addEventListener('change', () => syncCheckGroup(intChecks, intHidden)));

    // ── Navigation ─────────────────────────────────────────

    const goTo = (index) => {
      steps.forEach((s, i) => s.classList.toggle('hidden', i !== index));
      currentStep = index;
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validateStep = (stepEl) => {
      const required = stepEl.querySelectorAll('[required]');
      let valid = true;
      let firstInvalid = null;

      required.forEach((el) => {
        const invalid = el.type === 'checkbox' ? !el.checked : !el.value.trim();
        if (invalid) {
          if (el.type !== 'checkbox') el.style.borderColor = '#e53935';
          if (!firstInvalid) firstInvalid = el;
          valid = false;
        } else {
          if (el.type !== 'checkbox') el.style.borderColor = '';
        }
      });

      if (firstInvalid) firstInvalid.focus();
      return valid;
    };

    btnNexts.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (validateStep(steps[currentStep])) goTo(currentStep + 1);
      });
    });

    btnBacks.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = parseInt(btn.dataset.goto ?? currentStep - 1, 10);
        goTo(target);
      });
    });
  });
})();
